import { data, find, findAll } from './dom';
import { readStored, writeStored } from './storage';

const nicheKey = 'printarnica-delatnost';

// Ponuda za delatnost na početnoj: izbor (čip ili prozor „Sve“) prikazuje red proizvoda te delatnosti, a ponovni dodir
// istog čipa ga sklanja. Izbor se pamti između poseta. Bez skripte su delatnosti skrivene, a ostatak početne radi.
export function enhanceNiches(): void {
  const section = document.querySelector('[data-js="niches"]');
  if (!(section instanceof HTMLElement)) return;

  const chips = findAll(section, 'niche-chip', HTMLButtonElement);
  const shelves = findAll(document, 'niche-shelf', HTMLElement);
  const sheet = find(document, 'niche-sheet', HTMLDialogElement);

  const show = (niche: string | null): void => {
    chips.forEach(chip => chip.setAttribute('aria-pressed', String(data(chip, 'niche') === niche)));
    shelves.forEach(shelf => {
      shelf.hidden = data(shelf, 'niche') !== niche;
    });
    writeStored(nicheKey, niche ?? '');
  };

  chips.forEach(chip =>
    $(chip).on('click', () => show(chip.getAttribute('aria-pressed') === 'true' ? null : data(chip, 'niche')))
  );
  findAll(sheet, 'niche-pick', HTMLButtonElement).forEach(pick =>
    $(pick).on('click', () => {
      show(data(pick, 'niche'));
      sheet.close();
      shelves.find(shelf => !shelf.hidden)?.scrollIntoView({ block: 'nearest' });
    })
  );
  $(find(section, 'niche-sheet-open', HTMLButtonElement)).on('click', () => sheet.showModal());
  findAll(sheet, 'niche-sheet-close', HTMLButtonElement).forEach(button => $(button).on('click', () => sheet.close()));

  section.hidden = false;
  const stored = readStored(nicheKey);
  if (chips.some(chip => data(chip, 'niche') === stored)) show(stored);
}
